import { ShieldCheckIcon } from '@heroicons/react/24/outline';
import { Dumbbell, MessageCircleHeart } from 'lucide-react';
import { ElementType } from 'react';

const DailyPulseSection = () => {
  const cards: { icon: ElementType; title: string; description: string }[] = [
    {
      icon: MessageCircleHeart,
      title: 'My Daily Check-In',
      description: 'One simple question each day that keeps you connected to your health and your mind while gently updating your ThriveScore.'
    },
    {
      icon: Dumbbell,
      title: 'Stay Strong',
      description: 'Short activities that support balance, strength, and mental clarity designed for real life, not workouts.'
    },
    {
      icon: ShieldCheckIcon,
      title: 'Your ThriveScore',
      description: 'One number that shows how you are doing, combining your wellness, home safety, and daily activity into a simple progress tracker.'
    }
  ];

  return (
    <section id="daily-pulse" className="py-24 md:py-32 bg-gradient-to-b from-secondary/20 via-muted/40 to-background">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-4">
            How SeniorThrive Works for You Each Day
          </h2>
          <p className="text-lg md:text-xl text-muted-foreground">
            Independence isn't about big changes. It's a simple daily rhythm that keeps life running smoothly.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 lg:gap-8 max-w-6xl mx-auto">
          {cards.map((card, index) => {
            const IconComponent = card.icon;
            return (
              <div 
                key={index} 
                className="bg-card rounded-md p-8 shadow-raised hover:shadow-floating hover:-translate-y-0.5 transition-all duration-300 group"
              >
                <div className="flex items-center gap-4 mb-4">
                  <IconComponent className="w-8 h-8 text-primary flex-shrink-0" />
                  <h3 className="text-xl font-bold text-foreground">
                    {card.title}
                  </h3>
                </div>
                <p className="text-muted-foreground leading-relaxed">
                  {card.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default DailyPulseSection;
